import shootCover1 from "../assets/shootCover1.jpg";
import shootCover2 from "../assets/shootCover2.jpg";
import shootCover3 from "../assets/shootCover3.jpg";
import shootCover4 from "../assets/shootCover4.jpg";
import shootCover5 from "../assets/shootCover5.jpg";
import shootCover6 from "../assets/shootCover6.jpg";
// COUPLE 1
import img1 from "../assets/couple1/img1.jpg";
import img2 from "../assets/couple1/img2.jpg";
import img3 from "../assets/couple1/img3.jpg";
import img4 from "../assets/couple1/img4.jpg";
import img5 from "../assets/couple1/img5.jpg";
import img6 from "../assets/couple1/img6.jpg";
import img7 from "../assets/couple1/img7.jpg";
import img8 from "../assets/couple1/img8.jpg";
import img9 from "../assets/couple1/img9.jpg";
import img10 from "../assets/couple1/img10.jpg";
import img11 from "../assets/couple1/img11.jpg";
import img12 from "../assets/couple1/img12.jpg";
import img13 from "../assets/couple1/img13.jpg";
import img14 from "../assets/couple1/img14.jpg";
import img15 from "../assets/couple1/img15.jpg";
import img16 from "../assets/couple1/img16.jpg";
import img17 from "../assets/couple1/img17.jpg";
import img22 from "../assets/couple1/img22.jpg";
import img19 from "../assets/couple1/img19.jpg";
import img20 from "../assets/couple1/img20.jpg";
import video1 from "../assets/couple1/video1.mp4";
// COUPLE 2
import img1_coup2 from "../assets/couple2/img1_coup2.jpg";
import img2_coup2 from "../assets/couple2/img2_coup2.jpg";
import img3_coup2 from "../assets/couple2/img3_coup2.jpg";
import img4_coup2 from "../assets/couple2/img4_coup2.jpg";
import img5_coup2 from "../assets/couple2/img5_coup2.jpg";
import img6_coup2 from "../assets/couple2/img6_coup2.jpg";
import img7_coup2 from "../assets/couple2/img7_coup2.jpg";
import img8_coup2 from "../assets/couple2/img8_coup2.jpg";
import img9_coup2 from "../assets/couple2/img9_coup2.jpg";
import img10_coup2 from "../assets/couple2/img10_coup2.jpg";
import img11_coup2 from "../assets/couple2/img11_coup2.jpg";
import img12_coup2 from "../assets/couple2/img12_coup2.jpg";
import video_coup2 from "../assets/couple2/video_coup2.mp4";
// COUPLE 3
import img1_coup3 from "../assets/couple3/img1_coup3.jpg";
import img2_coup3 from "../assets/couple3/img2_coup3.jpg";
import img3_coup3 from "../assets/couple3/img3_coup3.jpg";
import img4_coup3 from "../assets/couple3/img4_coup3.jpg";
import img5_coup3 from "../assets/couple3/img5_coup3.jpg";
import img6_coup3 from "../assets/couple3/img6_coup3.jpg";
import img7_coup3 from "../assets/couple3/img7_coup3.jpg";
import img8_coup3 from "../assets/couple3/img8_coup3.jpg";
import img9_coup3 from "../assets/couple3/img9_coup3.jpg";
import img10_coup3 from "../assets/couple3/img10_coup3.jpg";
import img11_coup3 from "../assets/couple3/img11_coup3.jpg";
import img12_coup3 from "../assets/couple3/img12_coup3.jpg";
import img13_coup3 from "../assets/couple3/img13_coup3.jpg";
import img14_coup3 from "../assets/couple3/img14_coup3.jpg";
import img15_coup3 from "../assets/couple3/img15_coup3.jpg";
import img16_coup3 from "../assets/couple3/img16_coup3.jpg";
import video_coup3 from "../assets/couple3/video_coup3.mp4";
// COUPLE 4
import img1_coup4 from "../assets/couple4/img1_coup4.jpg";
import img2_coup4 from "../assets/couple4/img2_coup4.jpg";
import img3_coup4 from "../assets/couple4/img3_coup4.jpg";
import img4_coup4 from "../assets/couple4/img4_coup4.jpg";
import img5_coup4 from "../assets/couple4/img5_coup4.jpg";
import img6_coup4 from "../assets/couple4/img6_coup4.jpg";
import img7_coup4 from "../assets/couple4/img7_coup4.jpg";
import img8_coup4 from "../assets/couple4/img8_coup4.jpg";
import img9_coup4 from "../assets/couple4/img9_coup4.jpg";
import img10_coup4 from "../assets/couple4/img10_coup4.jpg";
import img11_coup4 from "../assets/couple4/img11_coup4.jpg";
import img12_coup4 from "../assets/couple4/img12_coup4.jpg";
import img13_coup4 from "../assets/couple4/img13_coup4.jpg";
import img14_coup4 from "../assets/couple4/img14_coup4.jpg";
import img15_coup4 from "../assets/couple4/img15_coup4.jpg";
import img16_coup4 from "../assets/couple4/img16_coup4.jpg";
// COUPLE 5
import img1_coup5 from "../assets/couple5/img1_coup5.jpg";
import img2_coup5 from "../assets/couple5/img2_coup5.jpg";
import img3_coup5 from "../assets/couple5/img3_coup5.jpg";
import img4_coup5 from "../assets/couple5/img4_coup5.jpg";
import img5_coup5 from "../assets/couple5/img5_coup5.jpg";
import img6_coup5 from "../assets/couple5/img6_coup5.jpg";
import img7_coup5 from "../assets/couple5/img7_coup5.jpg";
import img8_coup5 from "../assets/couple5/img8_coup5.jpg";
import img9_coup5 from "../assets/couple5/img9_coup5.jpg";
import img10_coup5 from "../assets/couple5/img10_coup5.jpg";
import img11_coup5 from "../assets/couple5/img11_coup5.jpg";
import img12_coup5 from "../assets/couple5/img12_coup5.jpg";
import img13_coup5 from "../assets/couple5/img13_coup5.jpg";
import img14_coup5 from "../assets/couple5/img14_coup5.jpg";
import img15_coup5 from "../assets/couple5/img15_coup5.jpg";
import img16_coup5 from "../assets/couple5/img16_coup5.jpg";
// COUPLE 6
import img1_coup6 from "../assets/couple6/img1_coup6.jpg";
import img2_coup6 from "../assets/couple6/img2_coup6.jpg";
import img3_coup6 from "../assets/couple6/img3_coup6.jpg";
import img4_coup6 from "../assets/couple6/img4_coup6.jpg";
import img5_coup6 from "../assets/couple6/img5_coup6.jpg";
import img6_coup6 from "../assets/couple6/img6_coup6.jpg";
import img7_coup6 from "../assets/couple6/img7_coup6.jpg";
import img8_coup6 from "../assets/couple6/img8_coup6.jpg";
import img9_coup6 from "../assets/couple6/img9_coup6.jpg";
import img10_coup6 from "../assets/couple6/img10_coup6.jpg";
import img11_coup6 from "../assets/couple6/img11_coup6.jpg";
import img12_coup6 from "../assets/couple6/img12_coup6.jpg";
import img13_coup6 from "../assets/couple6/img13_coup6.jpg";
import img14_coup6 from "../assets/couple6/img14_coup6.jpg";
import video_coup6 from "../assets/couple6/video_coup6.mp4";



const shoots = [
  {
    id: 4,
    title: "Susmitha & Srujan",
    location: "Udaipur, Rajasthan",
    description:
      "A royal wedding captured amidst lakes and palaces — pure elegance and tradition.",
    photos: [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img22, img19, img20],
    videos: [video1],
    cover : shootCover1
  },
  {
    id: 5,
    title: "Raagha & Prem",
    location: "Goa Beach Wedding",
    description:
      "Love and laughter captured against the sunset glow — candid moments of pure joy.",
    photos: [img1_coup2, img2_coup2, img3_coup2, img4_coup2, img5_coup2, img6_coup2, img7_coup2, img8_coup2, img9_coup2, img10_coup2, img11_coup2, img12_coup2],
    videos: [video_coup2],
    cover : shootCover2

  },
  {
    id: 6,
    title: "Ashwini & Manjunath",
    location: "Coorg, Karnataka",
    description:
      "A nature-inspired pre-wedding shoot that blends serenity, love, and forest vibes.",
    photos: [img1_coup3, img2_coup3, img3_coup3, img4_coup3, img5_coup3, img6_coup3, img7_coup3, img8_coup3, img9_coup3, img10_coup3, img11_coup3, img12_coup3, img13_coup3, img14_coup3, img15_coup3, img16_coup3],
    videos: [video_coup3],
    cover : shootCover3
  },
  {
    id: 3,
    title: "Supriya & Sai",
    location: "Tirupati Temple",
    description:
      "A traditional ceremony where devotion meets emotion in every frame.",
    photos: [img1_coup4, img2_coup4, img3_coup4, img4_coup4, img5_coup4, img6_coup4, img7_coup4, img8_coup4, img9_coup4, img10_coup4, img11_coup4, img12_coup4, img13_coup4, img14_coup4, img15_coup4, img16_coup4],
    videos: [],
    cover : shootCover4
  },
  {
    id: 2,
    title: "Spandana & Nithin",
    location: "Jaipur Fort",
    description:
      "Soft golden hues of dusk lighting up timeless love and togetherness.",
    photos: [img1_coup5, img2_coup5, img3_coup5, img4_coup5, img5_coup5, img6_coup5, img7_coup5, img8_coup5, img9_coup5, img10_coup5, img11_coup5, img12_coup5, img13_coup5, img14_coup5, img15_coup5, img16_coup5],
    videos: [],
    cover : shootCover5
  },
  {
    id: 1,
    title: "Sushmita & Vamsi",
    location: "Hyderabad",
    description:
      "Modern love captured amidst city lights — a cinematic wedding story.",
    photos: [img1_coup6, img2_coup6, img3_coup6, img4_coup6, img5_coup6, img6_coup6, img7_coup6, img8_coup6, img9_coup6, img10_coup6, img11_coup6, img12_coup6, img13_coup6, img14_coup6],
    videos: [video_coup6],
    cover : shootCover6
  },
];

export default shoots;